module.exports = __webpack_public_path__ + "img/2checkout.1bc26ca6.jpg";